var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_c('section',{staticClass:"content",attrs:{"id":"page-not-found"}},[_c('NotFoundContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }